<div class="head-data" *ngIf="!unloadingCompleted">
    <div class="welcome-details">
        <img class="" src="/assets/images/ff_logo.svg">
        <p>Welcome to FreightFox!</p>
    </div>

    <ng-container *ngIf="!isLoading; else loadingTemplate">

        <form class="otp-genration-form" [formGroup]="loginForm">
            <div class="form-feild">
                <label>Mobile number</label>
                <ng-container *ngIf="receiversContacts.length > 0; else mobInputTemplate">
                    <div class="custom-select-container">
                        <div class="custom-select" (click)="toggleSelect()" [class.open]="isSelectOpen">
                            <div class="select-display">
                                <span class="select-value" *ngIf="selectedReceiver; else placeholder">
                                    {{ selectedReceiver.name }} - {{ selectedReceiver.mobile }}
                                </span>
                                <ng-template #placeholder>
                                    <span class="select-placeholder">Select Receiver</span>
                                </ng-template>
                            </div>
                            <div class="select-arrow">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M7 10l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        
                        <!-- Custom Dropdown -->
                        <div class="custom-dropdown" *ngIf="isSelectOpen">
                            <div class="dropdown-options">
                                <div 
                                    *ngFor="let receiver of receiversContacts" 
                                    class="dropdown-option"
                                    [class.selected]="selectedReceiver && selectedReceiver.mobile === receiver.mobile"
                                    (click)="selectReceiver(receiver)">
                                    <span class="option-text">{{ receiver.name }} - {{ receiver.mobile }}</span>
                                    <span class="checkmark" *ngIf="selectedReceiver && selectedReceiver.mobile === receiver.mobile">✓</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #mobInputTemplate>
                    <mat-form-field  class="example-full-width topM-12 width-100">
                        <input matInput formControlName="username">
                    </mat-form-field>
                </ng-template>
                <mat-error *ngIf="loginForm.get('username').invalid && loginForm.get('username').touched" class="text-danger">Enter
                    Valid Email/Mobile number</mat-error>
                <p *ngIf="otpGenerated" class="otp-message"> Did not receive OTP yet? Press 'Resend OTP' for a new one.</p>
                <mat-error *ngIf="errorData" class="">Something Went Wrong!</mat-error>
            </div>
            <div class="form-feild form-margin-top" *ngIf="otpGenerated">
                <label>Enter OTP</label>
                <mat-form-field  class="example-full-width topM-12 width-100">
                    <input matInput formControlName="otp" >
                </mat-form-field>
                <mat-error *ngIf="loginForm.get('otp').invalid && loginForm.get('otp').touched" class="text-danger">Enter Valid OTP</mat-error>
               <div class="ff_flex otp-data">
                   <p class="remaning-time" ><span >{{remainingTime}}</span></p>
                   <p class="resend-otp" ><span  class="enabled" (click)="resendOTP()">Resend OTP</span></p>
               </div>
            </div>
            <div class="action form-margin-top">
                <button class="primary-btn" [disabled]="loginForm.invalid" (click)="otpGenerated?confirmOTP():generateOtp()">
                    {{otpGenerated?'Confirm OTP':'Generate OTP'}}
                </button>
            </div>
        </form>
    </ng-container>
    <ng-template #loadingTemplate>
        <div class="inline-loader">
            <div class="spinner"></div>
          </div>
    </ng-template>
</div>

<div class="submitted-data default-page-padding" *ngIf="unloadingCompleted">
    <p>Thank you!<br>
        The details of POD have been recorded.</p>
</div>
